import { Injectable }     from '@angular/core';
import { CanActivate, Router }    from '@angular/router';
import {AuthService} from "../user/auth.service";
import {LocalStorageService} from "angular-2-local-storage";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private userService: AuthService,
    private router: Router,
    private  localStorageService: LocalStorageService
  ) {}

  canActivate(): boolean {
    
    let logged = false;
    if(this.localStorageService.get("userData") || sessionStorage.getItem("userData")){
      logged = true;
    }
    else{
      logged = false;
    }
    return logged;

    /*
    // console.log("AuthGuard: CanActivate")
    const isAuth = this.userService.user != null && this.userService.user.token != null;
    // console.log("Auth guard check: " + isAuth);
    if (!isAuth) { this.router.navigateByUrl('login'); }
    return isAuth;
    */
  };
}



// WEBPACK FOOTER //
// ./src/app/services/utils/auth-guard.service.ts